import React from "react"
import { graphql } from "gatsby"
import Helmet from 'react-helmet'
import ImageHero from "../components/ImageHero"

const Event = ({ data: { prismicEvent } }) => {
  // const Event = ({
  //   data: {
  //     page,
  //   },
  // }) => {

  const { data } = prismicEvent
  
  return (
    <React.Fragment>
      <Helmet
        bodyAttributes={{
          class: "post event-post",
        }}
      />

      <ImageHero
        video={data.video.url}
        title={data.title.text}
      />

      <div className="section container">
        <div className="event-post-grid">
          <div className="event-post-grid__item">
            {/* <h1>{data.title.text}</h1> */}
            <h2>About this event</h2>
            <div dangerouslySetInnerHTML={{ __html: data.text.html }} />
          </div>
          <div className="event-post-grid__item">
            <h4>Date and time</h4>
            <p>{data.date}</p>
            <div dangerouslySetInnerHTML={{ __html: data.time.html }} />
            <h4>Location</h4>
            <p>{data.event_center.text}</p>
            <div dangerouslySetInnerHTML={{ __html: data.address.html }} />
            <h4>Admission</h4>
            <p>No refunds</p>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Event


export const pageQuery = graphql`
  query PostBySlug($uid: String!) {
    prismicEvent(uid: { eq: $uid }) {
      id
      uid
      data {
        title {
          text
        }
        video {
          url
        }
        text {
          html
        }
        date(formatString: "ddd, MMMM DD, YYYY")
        time {
          html
        }
        featured_image {
          size
          url
        }
        google_maps {
          longitude
          latitude
        }
        address {
          html
        }
        event_center {
          text
        }
      }
    }
  }
`